export default "__VITE_ASSET__BdY23uax__"